// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "specialist-260910-46/static/css/" + chunkId + "." + {"252":"3d0d1673","679":"8a24132f","725":"84c1fc5e"}[chunkId] + ".chunk.css";
};